import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import logo from '../logo.png';

const API_BASE = '/api';

export default function VideoDownload() {
  const { jobId } = useParams();
  const [videoData, setVideoData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/jobs/${jobId}`)
      .then(res => {
        if (!res.ok) throw new Error("Video not found or link expired");
        return res.json();
      })
      .then(data => setVideoData(data))
      .catch(err => setError(err.message));
  }, [jobId]);

  return (
    <div className="app-wrapper">
      <div className="screen">
        <img src={logo} alt="Pixperience" className="logo" />
        
        {error ? (
          <>
            <div className="emoji-huge">😕</div>
            <h1>Oops!</h1>
            <p className="subtitle">{error}</p>
          </>
        ) : !videoData ? (
          <>
            <div className="loader"></div>
            <h1>Loading Video...</h1>
          </>
        ) : (
          <>
            <h1>Your Video is Ready!</h1>
            <p className="subtitle">Tap the button below to save it to your device.</p>
            
            <div className="media-container" style={{ aspectRatio: 'auto' }}>
              {/* Uses the play_url for streaming */}
              <video 
                src={videoData.play_url} 
                controls 
                playsInline 
                autoPlay
                loop
                className="media-element"
              />
            </div>
            
            {/* Uses download_url + the download attribute for cross-platform downloading */}
            <a 
              href={videoData.download_url} 
              className="btn" 
              style={{ textDecoration: 'none' }}
            >
              Download Video ⬇️
            </a>
          </>
        )}
      </div>
    </div>
  );
}